import { DocCollection } from '@blocksuite/store';

export { DocCollection };

export enum WorkspaceSubPath {
  ALL = 'all',
  SHARED = 'shared',
  HOME = 'home',
}

export const WorkspaceSubPathName = {
  [WorkspaceSubPath.ALL]: 'All Pages',
  [WorkspaceSubPath.SHARED]: 'Shared',
  [WorkspaceSubPath.HOME]: 'Home',
} satisfies {
  [Path in WorkspaceSubPath]: string;
};

export const pathGenerator = {
  all: workspaceId => `/workspace/${workspaceId}/all`,
  shared: workspaceId => `/workspace/${workspaceId}/shared`,
  home: workspaceId => `/workspace/${workspaceId}/home`,
} satisfies {
  [Path in WorkspaceSubPath]: (workspaceId: string) => string;
};
